import React, {useState, createRef, useEffect} from 'react';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledRadioButton = styled(Button)(({theme, activebutton}) => ({
  backgroundColor: activebutton === 'true' ? theme.buttonSettingIcon.backgroundActiveColor : theme.buttonSettingIcon.backgroundColor,
  color: activebutton === 'true' ? theme.buttonSettingIcon.contrastTextActive :  theme.buttonSettingIcon.contrastText,
  textTransform: 'none',
  borderRadius: '100vmax',
  border: activebutton === 'true' ? '2px solid': 'none',
  '&:hover': {
    backgroundColor: theme.palette.common.hover,
    color: theme.palette.common.texthover,
    border: '2px solid'
  }
}));

const RadioButtonRef = (props, ref) => {
  const {id, selected, label, value, callbackFunction, icon} = props;
  return (
    <StyledRadioButton
      id={id}
      onClick={() => callbackFunction()} 
      variant={selected ? 'contained': 'outlined'} 
      role="radio" 
      size='small'
      startIcon={icon ?  
        <Avatar alt='' src={icon} variant="square" sx={{ width: 20, height: 20 }}/> : null
      }
      aria-checked={selected ? true: false} 
      tabIndex={selected ? 0: -1}
      activebutton={selected? 'true': 'false'}
      value={value}
      ref={ref}
    >
      {label}
    </StyledRadioButton>
  );
};

const RadioButton = React.forwardRef(RadioButtonRef);

export const RadioButtons = ({labelledby, callbackFunction, valueList, labelList, iconList}) => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  const refList =valueList.map(() => createRef());

  const modifyDistanceValue = (index) => {
    callbackFunction(valueList[index]);
    setSelectedIndex(index);
  };

  useEffect(() => {
    modifyDistanceValue(0);
  }, [valueList]);

  const setCheckedToPreviousItem = () => {
    if (selectedIndex === 0) {
      return valueList.length -1;
    } else {
      return selectedIndex - 1;
    }
  };

  const setCheckedToNextItem = () => {

    if (selectedIndex === valueList.length -1) {
      return 0;
    } else {
      return selectedIndex + 1;
    }
  };

  const handleKeyDown = (event) => {
    var flag = false;
    var newIndex = selectedIndex;
    switch (event.key) {
      case ' ':
      case 'Enter':
        modifyDistanceValue(Number(event.target.value));
        flag = true;
        break;
        

      case 'Up':
      case 'ArrowUp':
      case 'Left':
      case 'ArrowLeft':
        newIndex = setCheckedToPreviousItem();
        modifyDistanceValue(newIndex);
        refList[newIndex].current.focus();
        flag = true;
        break;

      case 'Down':
      case 'ArrowDown':
      case 'Right':
      case 'ArrowRight':
        newIndex = setCheckedToNextItem();
        modifyDistanceValue(newIndex);
        refList[newIndex].current.focus();
        flag = true;
        break;

      default:
        break;
    }
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  const styles = {
    container: {
      flexWrap: 'wrap', 
      listStyle: 'none', 
      paddingLeft: 0
    },
    itemsContainer: {
      marginTop: '.5em',
      marginRight: '.5em'
    }
  };

  return (
    <Stack 
      sx={styles.container}
      onKeyDown={event=>handleKeyDown(event)} 
      aria-labelledby={labelledby} 
      role="radiogroup" 
      direction='row' 
      spacing={0} 
      component='ul'
    >
      {
        Object.keys(valueList).map(function(index) {
          return (
            <Box key={index} component='li' sx={styles.itemsContainer}>
              <RadioButton 
                id={`${valueList[index]}_radio`}
                key={index} 
                ref={refList[index]} 
                selected={selectedIndex==index ? true: false} 
                label={labelList[index]} 
                icon={iconList && iconList[index]}
                value={index}
                callbackFunction={() => modifyDistanceValue(index)}
              />
            </Box>
          );
        })
      }
    </Stack>
  );
};
